import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"color":_vm.snackbarColor,"top":true},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  "+_vm._s(_vm.snackbarMessage)+"\n  "),_c(VBtn,{attrs:{"dark":"","text":""},on:{"click":_vm.snackbarHide}},[_vm._v("\n    Close\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }